import ThemeTableDetail from './container';

export default ThemeTableDetail;



// WEBPACK FOOTER //
// ./src/components/ThemeTableDetail/index.js